/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryListingMaxPrice
 */

import { MAX_FILTER_PRICE } from '@zcode-ui/filters'
import type { Filters } from '@zcode/state-type'
import { isNumber } from '@zcode/utils'

import { QUERY_PRICE_DELTA } from '../constants'

export const getQueryListingMaxPrice = ({
  filters,
  price,
}: {
  filters: Partial<Filters> | undefined
  price: number | null | undefined
}) => {
  const filtersMaxPriceIsValid =
    filters &&
    isNumber(filters.maxPrice) &&
    (filters.maxPrice !== MAX_FILTER_PRICE || filters.customMaxPrice)

  if (isNumber(price)) {
    const entityMaxPrice = Math.round(price * (1 + QUERY_PRICE_DELTA))

    return filtersMaxPriceIsValid ? Math.max(entityMaxPrice, filters.maxPrice) : entityMaxPrice
  } else if (filtersMaxPriceIsValid) {
    return filters.maxPrice
  }

  return null
}
